import { Injectable } from '@angular/core';
import { GlobalVariable } from '.././config/service.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';

const helper = new JwtHelperService();

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  url = GlobalVariable.BASE_API_URL;
  token = `Bearer ${JSON.parse(localStorage.getItem('token'))}`;
  headersc = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json');
  constructor(private http: HttpClient, private router: Router) { }

  logIn(user: string, clave: string) {
    return this.http.post(`${this.url}Auth/authenticate/?user=${user}&clave=${clave}`, null, { headers: this.headersc });
  }
  getToken() {
    return localStorage.getItem('token');
  }
  setToken(data: any) {
    localStorage.setItem('token', JSON.stringify(data.Token));
  }
  logOffFull() {
    localStorage.removeItem('token');

    setTimeout(() => {
      this.router.navigateByUrl('/login');
    }, 1000);
  }
  refreshToken() {
    const head = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: this.token.replace(/["']/g, '')
    });
    return this.http.post(`${this.url}Token/RefreshToken`, null, { headers: head });
  }

  setRefToken(data) {
    localStorage.setItem('token', JSON.stringify(data));
  }
  GetUserToken(): any {
    const json = localStorage.getItem('token');
    if (json !== null) {
      return helper.decodeToken(json);
    }
    return null;
  }
  ValidarAlumno(rut) {
    return this.http.post(`${this.url}Auth2/validUser/?rut=${rut}`, null, { headers: this.headersc });
  }
}
